import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { TabProps } from '../types';

import { capPlanSchema } from '../utils';

import Grid from '@mui/material/Grid';

import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

const ControlledNumericFieldWithReadMode = withReadModeField(
  ControlledNumericField
);

const CapPlanTab = ({ setCurrentSchema }: TabProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla'
  });

  useEffect(() => {
    setCurrentSchema(capPlanSchema);
  }, []);

  return (
    <>
      <MultiStepForm.Section title={t('capReferenceNetHours')}>
        <Grid item style={{ maxWidth: '32%' }}>
          <ControlledNumericFieldWithReadMode
            name={'capReferenceNetHours'}
            label={t('averageReference')}
            variant={'outlined'}
          />
        </Grid>
      </MultiStepForm.Section>
    </>
  );
};

export default CapPlanTab;
